import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Alert from '@spothero/ui/alert';
import Button from '@spothero/ui/button';
import Loader from '@spothero/ui/loader';
import SpotUtils from 'utils/spot';

const SpotDetailsReservationSummary = ({
    reservationLabel,
    priceLabel,
    isMobile,
    isLoadingRates,
    displayPrice,
    currencyType,
    reservationDateTimeFormatted,
    isReservationExtended,
    showSpotUnavailable,
    onBookSpotClick,
    isSticky,
    isShowing,
}) => {
    const displayPriceFormatted = SpotUtils.formatRatePrice({
        price: displayPrice,
        currencyType,
    });
    const containerClasses = classNames([
        'SpotDetailsReservationSummary',
        {'SpotDetailsReservationSummary-sticky': isSticky},
        {showing: isSticky && isShowing},
    ]);

    return (
        <div className={containerClasses}>
            <div className="SpotDetailsReservationSummary-reservation-and-price">
                <div className="SpotDetailsReservationSummary-reservation">
                    <h3 className="SpotDetailsReservationSummary-reservation-label">
                        {reservationLabel}
                    </h3>
                    <span className="SpotDetailsReservationSummary-reservation-date-times">
                        {reservationDateTimeFormatted}{' '}
                        {isLoadingRates && (
                            <Loader size={isMobile ? 14 : 16} borderWidth={3} />
                        )}
                    </span>
                </div>
                <div className="SpotDetailsReservationSummary-price-container">
                    <span
                        className="price"
                        dangerouslySetInnerHTML={{
                            __html: displayPriceFormatted,
                        }}
                    />
                    <span className="price-label">{priceLabel}</span>
                </div>
            </div>
            {!isSticky && isReservationExtended && (
                <small className="SpotDetailsReservationSummary-auto-extension">
                    Your reservation was extended at no extra charge!
                </small>
            )}
            {showSpotUnavailable ? (
                <Alert type="danger" className="text-center">
                    This spot is not available at the selected times. Please
                    adjust your times.
                </Alert>
            ) : (
                <Button
                    color="primary"
                    className="SpotDetailsReservationSummary-book-now Button-primary-booking-flow"
                    onClick={onBookSpotClick}
                >
                    Book Now
                </Button>
            )}
        </div>
    );
};

SpotDetailsReservationSummary.propTypes = {
    reservationLabel: PropTypes.string,
    priceLabel: PropTypes.string,
    isMobile: PropTypes.bool,
    isLoadingRates: PropTypes.bool,
    displayPrice: PropTypes.number,
    currencyType: PropTypes.string,
    reservationDateTimeFormatted: PropTypes.string,
    isReservationExtended: PropTypes.bool,
    showSpotUnavailable: PropTypes.bool,
    onBookSpotClick: PropTypes.func.isRequired,
    isSticky: PropTypes.bool,
    isShowing: PropTypes.bool,
};

SpotDetailsReservationSummary.defaultProps = {
    reservationLabel: 'Parking Reservation',
    priceLabel: 'total',
    isReservationExtended: false,
};

export default SpotDetailsReservationSummary;
